import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { Templates_Get_All, Templates_Initialize } from "../api/API_Templates";
import { Context_UI } from "./Context_UI";
import App_Properties from "../Assets/Resource_Files/App_Properties";

const Context_Progressor = createContext();

export default function Context_Provider_Progressor({ children }) {

    const [Progress, Progress_Set] = useState({
        State: "Ready",
        Count_Total: 0,
        Count_Current: 0,
        Percent_Current: 0.0
    });

    return (
        <Context_Progressor.Provider value={{
            Progress,
            Progress_Set

        }}>
            {children}
        </Context_Progressor.Provider>
    )
}

export function useProgressor() {
    return useContext(Context_Progressor);
}